import React from 'react';
const EmbeddedContext = React.createContext({
    isEmbedded: false,
});
export default EmbeddedContext;
//# sourceMappingURL=embedded.js.map